import React from "react";

const InvoiceTypeCard = ({ icon, type, title, subtitle, onClick }) => {
  return (
    <div
      className="invoice-creation-card"
      onClick={() => {
        onClick(type);
      }}
    >
      <div className="card-icon-wrapper">
        <img src={icon} alt="Search Logo" />
      </div>
      <p className="invoice-text title"> {title} </p>
      <p className="invoice-text subtitle"> {subtitle} </p>
    </div>
  );
};

export default InvoiceTypeCard;
